// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"945b1665","601":"c8aa75f7"}[chunkId] + ".chunk.js";
};